/* WIT product card — colourway swatch preview.
   Hovering (or focusing) a colour dot previews that colourway's image on the
   card; moving away reverts. Clicking a dot is a normal link to its PDP.

   Note: these cards use second-image-on-hover, and hovering the swatch also
   triggers .wit-card:hover (so the secondary image would otherwise cover the
   swapped image). So while previewing we force the primary image visible and
   hide the secondary, then clear those overrides on leave. */
(function () {
  function card(el) { return el.closest('.wit-card'); }

  class WitCardSwatches extends HTMLElement {
    connectedCallback() {
      if (this._bound) return;
      this._bound = true;
      this.addEventListener('mouseover', this.onEnter.bind(this));
      this.addEventListener('focusin', this.onEnter.bind(this));
      this.addEventListener('mouseleave', this.restore.bind(this));
      this.addEventListener('focusout', this.onFocusOut.bind(this));
    }

    refs() {
      const c = card(this);
      if (!c) return null;
      return {
        img: c.querySelector('[data-wit-card-img]'),
        hover: c.querySelector('.wit-card__media-hover'),
      };
    }

    onEnter(e) {
      const dot = e.target.closest('.wit-card__swatch[data-media]');
      if (!dot || !this.contains(dot)) return;
      const r = this.refs();
      if (!r || !r.img) return;

      const media = dot.dataset.media;
      if (media) {
        if (r.img.dataset.witOrigSrc === undefined) {
          r.img.dataset.witOrigSrc = r.img.getAttribute('src') || '';
          r.img.dataset.witOrigSrcset = r.img.getAttribute('srcset') || '';
        }
        r.img.removeAttribute('srcset');
        r.img.src = media;
      }
      // Make the swapped (primary) image win over the second-image hover effect.
      r.img.style.setProperty('opacity', '1', 'important');
      if (r.hover) r.hover.style.setProperty('opacity', '0', 'important');
    }

    onFocusOut(e) {
      if (!this.contains(e.relatedTarget)) this.restore();
    }

    restore() {
      const r = this.refs();
      if (!r || !r.img) return;
      if (r.img.dataset.witOrigSrc !== undefined) {
        if (r.img.dataset.witOrigSrc) r.img.src = r.img.dataset.witOrigSrc;
        if (r.img.dataset.witOrigSrcset) r.img.setAttribute('srcset', r.img.dataset.witOrigSrcset);
        else r.img.removeAttribute('srcset');
      }
      r.img.style.removeProperty('opacity');
      if (r.hover) r.hover.style.removeProperty('opacity');
    }
  }

  if (!customElements.get('wit-card-swatches')) {
    customElements.define('wit-card-swatches', WitCardSwatches);
  }
})();